import styled from 'styled-components';
import { colors, shadeHex } from '@karnott/colors';
import { DeleteIcon, ShowLabelIcon } from '@karnott/icons';
import { Container, Icon, Label } from '../shared';

const DeleteButton = styled.button<{
  small: boolean;
  backgroundColor: string;
}>`
  all: unset;
  cursor: pointer;
  display: none;
  position: absolute;
  right: 0;
  padding: ${({ small }) => (small ? 4 : 7)}px;
  background-color: ${({ backgroundColor }) => backgroundColor};
  border-radius: 0 100px 100px 0;
`;

type Props = {
  /** Color of the font (hex). The background color is automatically generated from this color */
  color: string;
  /** Label of the tag */
  label: string;
  /** If true, the tag is smaller */
  small?: boolean;
  /** If true, a delete button appears on hover */
  canDelete?: boolean;
  /** Callback when the delete button is clicked */
  onDelete?: () => void;
};

/** A user-defined tag describing an entity */
export function CustomTag({ color, label, small = false, canDelete = false, onDelete }: Props) {
  const backgroundColor = shadeHex(color, 0.8) || colors('grey');

  return (
    <Container $color={color} backgroundColor={backgroundColor} small={small}>
      {small ? null : (
        <Icon>
          <ShowLabelIcon size={12} color={color} />
        </Icon>
      )}

      <Label>{label}</Label>

      {canDelete ? (
        <DeleteButton
          className="tag-delete-button"
          data-testid="tag-delete-button"
          backgroundColor={backgroundColor}
          onClick={onDelete}
          small={small}
        >
          <DeleteIcon size={10} circled backgroundColor={color} color={backgroundColor} />
        </DeleteButton>
      ) : null}
    </Container>
  );
}
